<template>
  <div class="container">
    <LandingPage v-if="$route.name === 'landing'" />
    <LoginPage v-else-if="$route.name === 'login'" />
    <SignupPage v-else-if="$route.name === 'signup'" />
    <ForgotPasswordPage v-else-if="$route.name === 'forgotpassword'" />
    <ResetPasswordPage v-else-if="$route.name === 'reset'" />
    <JoinOrgRequestPage v-else-if="$route.name === 'joinOrgRequest'" />
    <PrivacyPolicyPage v-else-if="$route.name === 'privacy'" />
    <TermsOfServicePage v-else-if="$route.name === 'terms'" />
    <TPMTermsOfServicePage v-else-if="$route.name === 'tpmterms'" />

    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer.vue'
import LandingPage from '@/pages/LandingPage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import SignupPage from '@/pages/SignupPage.vue'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage.vue'
import ResetPasswordPage from '@/pages/ResetPasswordPage.vue'
import JoinOrgRequestPage from '@/pages/JoinOrgRequestPage.vue'
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage.vue'
import TermsOfServicePage from '@/pages/TermsOfServicePage.vue'
import TPMTermsOfServicePage from '@/pages/TPMTermsOfServicePage.vue'

export default {
  name: 'LoggedOutContent',
  components: {
    Footer,
    LandingPage,
    LoginPage,
    SignupPage,
    ForgotPasswordPage,
    ResetPasswordPage,
    JoinOrgRequestPage,
    PrivacyPolicyPage,
    TermsOfServicePage,
    TPMTermsOfServicePage
  }
}

</script>
